import {assertionsList} from '../../../util/uiconstants';

const mapAssertion = (assertion) => ({
	...assertion,
	assertionAbbreviation:
		assertionsList.find(({ids}) => ids?.includes(parseInt(assertion.knowledgeAssertionId)))?.abbreviation ?? ''
});

export default (assertions) => {
	return assertions?.map(mapAssertion);
};
